import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_MEDIA,
  GET_KATEGORI_MEDIA,
  SET_LOADING_DATA_MEDIA,
  SET_LOADING_KATEGORI_MEDIA,
  SET_PAGINATION_DATA_MEDIA,
  SET_PAGINATION_KATEGORI_MEDIA,
} from '../constant.js';

export const getKategoriMedia = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_KATEGORI_MEDIA,
      payload: true,
    });
    API.get(`admin/media/cat?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_KATEGORI_MEDIA,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_MEDIA,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_KATEGORI_MEDIA,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_KATEGORI_MEDIA,
          payload: 0,
        });
      });
  };
};

export const addKategoriMedia = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/media/cat/add", params);
};

export const getDetailKategoriMedia = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/media/cat/${code}`);
};

export const updKategoriMedia = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/media/cat/edit", params);
};

export const delKategoriMedia = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/media/cat/delete/" + code);
};

export const getDataMedia = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_MEDIA,
      payload: true,
    });
    API.get(`admin/news/media?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_DATA_MEDIA,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_MEDIA,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_MEDIA,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_MEDIA,
          payload: 0,
        });
      });
  };
};

export const addDataMedia = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/media/add", params);
};

export const getDetailDataMedia = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/news/media/${code}`);
};

export const updDataMedia = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/media/edit", params);
};

export const delDataMedia = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/news/media/delete/" + code);
};
